import React, {useEffect} from 'react';
import './App.css';
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import {getAnalytics} from "firebase/analytics";
import {AuthProvider} from "./utils/AuthProvider";
import '@fontsource/inter';
import {Box, CssBaseline, CssVarsProvider, extendTheme} from "@mui/joy";
import {Router} from "./utils/Router";
import {FeedbackProvider} from "./utils/FeedbackContext";
import "./utils/i18n";

if (!firebase.apps.length) {
    const app = firebase.initializeApp({
        apiKey: "AIzaSyAGgHFzcmNMPSItG5PyGNHVYac1D3wJ-e0",
        authDomain: "cinefxapp.firebaseapp.com",
        projectId: "cinefxapp",
        storageBucket: "cinefxapp.firebasestorage.app",
        messagingSenderId: "291918352599",
        appId: "1:291918352599:web:b2b69b77a900295382e092",
        measurementId: "G-Z9V0RX0C48"
    })
    getAnalytics(app);
}

const baseTheme = extendTheme();
const darkOnlyTheme = extendTheme({
    cssVarPrefix: "sidebar_",
    colorSchemes: {
        light: baseTheme.colorSchemes.dark,
        dark: baseTheme.colorSchemes.dark,
    },
});

function App() {

    useEffect(() => {
        console.info('\x1b[34m%s\x1b[0m', // \x1b[38;5;33m
            "\n\n" +
            "         Developed with <3 by\n" +
            "         DANIELE DI GREGORIO\n" +
            "      cinefx.danieledigregorio.it\n")
    }, []);

    return (
        <div>
            <AuthProvider>
                <FeedbackProvider>
                    <CssVarsProvider theme={darkOnlyTheme} defaultMode="light">
                        <CssBaseline />
                        <Box sx={{
                            minHeight: '100%',
                            maxWidth: '100vw',
                            backgroundColor: "var(--joy-palette-background-body)",
                        }}
                        >
                            <Router />
                        </Box>
                    </CssVarsProvider>
                </FeedbackProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
